import { render, staticRenderFns } from "./MediaChooser.vue?vue&type=template&id=6007a8dd&"
import script from "./MediaChooser.vue?vue&type=script&lang=js&"
export * from "./MediaChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports